import { Directory, DirectoryChildren } from './directory'

export class DirectoryWithIcon extends Directory<DirectoryChildren> {
    icon: {
        name: string
        variant?: string
    }

    readonly type = 'directoryWithIcon'

    constructor(
        title: string,
        slug: string,
        icon: { name: string; variant?: string }
    ) {
        super(title, slug)
        this.icon = icon
    }
}
